import { render, staticRenderFns } from "./AllTransactions.vue?vue&type=template&id=56b8d37a"
import script from "./AllTransactions.vue?vue&type=script&lang=js"
export * from "./AllTransactions.vue?vue&type=script&lang=js"
import style0 from "./AllTransactions.vue?vue&type=style&index=0&id=56b8d37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports